<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-gerenxinxi"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.personalInformation') }}</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <el-form @submit.native.prevent class="table_header tableSearchForm"  size="small" label-width="80px" label-position="left">
                <el-form-item :label="$t('ems.userAvatar')"> 
                    <el-upload
                            class="avatar-uploader"
                            action="/api/blade-wems/config/upload"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <img v-if="form.avatar" :src="baseUrl + form.avatar" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">{{ $t('ems.userAvatarUploadTip') }}</div> 
                    </el-upload>
                </el-form-item>
                <el-form-item :label="$t('ems.realName')"><el-input v-model="form.realName" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input></el-form-item>
                <el-form-item :label="$t('ems.ContactInformation')"><el-input v-model="form.phone" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input></el-form-item>
                <div class="sumbin">
                    <div class="btn btn_active" @click="saveUser" style="border-width: 1px"><i class="iconfont icon-baocun"></i><span>{{ $t('ems.strategy.save') }}</span></div>
                    <div class="btn btn_active" @click="resetUser" style="border-width: 1px"><i class="iconfont icon-reset"></i><span>{{ $t('ems.alarm.reset') }}</span></div> 
                </div>
            </el-form>
            <div class="line"></div>
            <el-form @submit.native.prevent class="table_header1 tableSearchForm"  size="small" label-width="80px" label-position="left">
                <el-form-item :label="$t('ems.oldPassword')"><el-input type="password" v-model="passwordForm.oldPassword" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input></el-form-item>
                <el-form-item :label="$t('ems.newPassword')"><el-input type="password" v-model="passwordForm.newPassword" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input></el-form-item>
                <el-form-item :label="$t('ems.newPassword1')"><el-input type="password" v-model="passwordForm.newPassword1" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input></el-form-item>
                <div class="sumbin">
                    <div class="btn btn_active" @click="save" style="border-width: 1px"><i class="iconfont icon-baocun"></i><span>{{ $t('ems.strategy.save') }}</span></div>
                    <div class="btn btn_active" @click="reset" style="border-width: 1px"><i class="iconfont icon-reset"></i><span>{{ $t('ems.empty') }}</span></div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import spmsweb from '@/config/spmsweb';
    import { getStore } from "@/utils/store";
    import { Base64 } from 'js-base64';
    import { getUserDetails, updateUser, updatePassword } from "@/api/spms";
    import md5 from "md5";
    import i18n from "@/lang";

    export default {
        name: "mainSys",
        inject: ["getUserInfo"],
        data(){
            return{
                opacity: 0,
                loading: false,
                form: {
                    avatar: '',
                    realName: '',
                    phone: '',
                },
                passwordForm: {
                    oldPassword: '',
                    newPassword: '',
                    newPassword1: '',
                },
                baseUrl: imgBaseUrl ,
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        created(){
            this.headers = {
                Authorization: `Basic ${Base64.encode(
                    `${spmsweb.clientId}:${spmsweb.clientSecret}`
                )}`,
                "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
                // 'Content-Type': 'application/json'
            };
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
            this.loadUser();
        },
        methods: {
            handleAvatarSuccess(res) {
                this.form.avatar =  res.data;
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error(i18n.t('ems.uploadedAvatarPicturetype')); 
                }
                if (!isLt2M) {
                    this.$message.error(i18n.t('ems.sizeUploadedPictureExceed')); 
                }
                return isJPG && isLt2M;
            },
            loadUser(){
                const user = this.getUserInfo();
                getUserDetails(user.user_id).then(res => {
                    this.form = res.data.data;
                });
            },
            saveUser(){
                const params = {...this.form};
                if(!params.realName){
                    this.$message.warning(i18n.t('ems.PleaseFillUserName')); 
                    return false;
                }
                updateUser(params).then(() => {
                    this.$message.success(i18n.t('ems.ModifyInformationSuccessfully'));
                }).catch(err => {
                    this.$message.error(i18n.t('ems.FailedModifyInformation')); 
                    console.log(err)
                });
            },
            resetUser(){
                const user = this.getUserInfo();
                getUserDetails(user.user_id).then(res => {
                    this.form = res.data.data;
                });
            },
            save(){
                if(this.passwordForm.oldPassword === "" || this.passwordForm.newPassword === "" || this.passwordForm.newPassword1 === ""){
                    this.$message.warning(i18n.t('ems.PleaseEnterPassword'));
                    return false;
                }
                if(this.passwordForm.newPassword !== this.passwordForm.newPassword1){
                    this.$message.warning(i18n.t('ems.RepeatedInputPasswordsInconsistent'));
                    return false;
                }
                const user = this.getUserInfo();
                const params = {
                    oldPassword: md5(this.passwordForm.oldPassword),
                    newPassword: md5(this.passwordForm.newPassword),
                    newPassword1: md5(this.passwordForm.newPassword1),
                    userId: user.user_id
                };

                updatePassword(params).then(() => {
                    this.$message.success(i18n.t('ems.PasswordResetComplete')) 
                }).catch(err => {
                    console.log(err);
                    this.$message.error(i18n.t('ems.PasswordModificationFailed')) 
                });
            },
            reset() {
                this.passwordForm = {
                    oldPassword: '',
                    newPassword: '',
                    newPassword1: '',
                };
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
        }
        .content{
            overflow: hidden;
            height: calc(100% - 52px);
            box-sizing: border-box;
            padding: 20px;
            position: relative;
            display: flex;
            align-items: center;
            .table_header{
                width: 50%;
                height: 100%;
                background-color: var(--nav);
                border: #595959 solid 1px;
                box-sizing: border-box;
                color: white;
                position: relative;
                padding-top: 50px;
                padding-left: 80px;
            }
            .table_header1{
                margin-left: 10px;
                width: 50%;
                height: 100%;
                background-color: var(--nav);
                border: #595959 solid 1px;
                box-sizing: border-box;
                color: white;
                position: relative;
                padding-top: 50px;
                padding-left: 80px;
            }
            .sumbin{
                position: absolute;
                bottom: 12%;
                left: 0;
                width: 100%;
                text-align: center;
            }
        }
    }
</style>
<style lang="scss">
    .table_header1, .table_header {
        .el-form-item__label {
            color: var(--input_font) !important;
            font-size: 16px !important;
        }

        .avatar-uploader {
            .el-upload {
                border: 1px dashed  rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }
            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }
        }
    }
</style>